import * as React from 'react';
import {useParams} from 'react-router-dom';
import {TicketDetailByIdRoute} from './TicketDetailByIdRoute';
import {TicketDetailBySlugRoute} from './TicketDetailBySlugRoute';

// Matches "ACME-1042" — one or more uppercase letters/digits starting with a
// letter, followed by a hyphen and one or more digits. Keep in sync with the
// server's slug format (TN-D / ACC-275).
const SLUG_PATTERN = /^[A-Z][A-Z0-9]{1,9}-\d+$/;

export function TicketDetailRoute() {
	const {id: param} = useParams<{id: string}>();
	if (!param) return null;
	return SLUG_PATTERN.test(param) ? <TicketDetailBySlugRoute slug={param} /> : <TicketDetailByIdRoute id={param} />;
}
